export default __webpack_public_path__ + "static/media/variable_annuity_dark.bfd28127.png";